import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  LanguageSelectorContainer, 
  LanguageSwitch,
  SwitchSlider,
  LanguageLabel,
  FlagImage
} from './styles';
import { changeLanguage } from '../../utils/terminalUtils';
import { GB as GBFlag, TR as TRFlag } from 'country-flag-icons/react/3x2';

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();
  
  // Mevcut dil kodunu al
  const currentLanguage = i18n.language.startsWith('tr') ? 'tr' : 'en';
  
  // Switch tıklandığında dil değiştirme
  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'tr' ? 'en' : 'tr';
    i18n.changeLanguage(newLanguage);
    changeLanguage(newLanguage as 'tr' | 'en');
  };
  
  // SVG bayraklar için temel stil
  const flagBaseStyle = {
    position: 'absolute' as 'absolute',
    borderRadius: '50%'
  };
  
  // İngiliz bayrağı için özel stil - 3:2 oranında
  const gbFlagStyle = {
    ...flagBaseStyle,
    width: '145%',
    height: '145%',
    transform: 'translate(0%, 0%)',
  };
  
  // Türk bayrağı için özel stil - 3:2 oranında, yıldızı ortalamak için
  const trFlagStyle = {
    ...flagBaseStyle,
    width: '155%',
    height: '155%',
    transform: 'translate(6.5%, 0%)',
  };
  
  
  return (
    <LanguageSelectorContainer className="language-selector">
      <LanguageSwitch 
        onClick={toggleLanguage} 
        title={currentLanguage === 'tr' ? 'İngilizceye geç' : 'Switch to Turkish'}
        aria-label={currentLanguage === 'tr' ? 'İngilizceye geç' : 'Switch to Turkish'}
      >
        {/* Sadece pasif dil etiketi görünecek */}
        <LanguageLabel $isActive={currentLanguage === 'tr'}>TR</LanguageLabel>
        <LanguageLabel $isActive={currentLanguage === 'en'}>EN</LanguageLabel>
        
        {/* Slider üzerinde bayrak gösterimi */}
        <SwitchSlider $isEN={currentLanguage === 'en'}>
          <FlagImage>
            {currentLanguage === 'tr' ? (
              <TRFlag title="Türk Bayrağı" style={trFlagStyle} />
            ) : (
              <GBFlag title="British Flag" style={gbFlagStyle} />
            )}
          </FlagImage>
        </SwitchSlider>
      </LanguageSwitch>
    </LanguageSelectorContainer>
  );
};

export default LanguageSelector; 